{
  "name": "company-management",
  "version": "0.0.0",
  "private": true,
  "scripts": {
    "build": "node generate-meta.js && ng build --configuration=$npm_config_configuration",
    "format": "prettier --write \"src/**/*.{ts,html,scss,css,json}\"",
    "ng": "ng",
    "start": "ng serve",
    "test": "ng test",
    "watch": "ng build --watch --configuration dev"
  },
  "dependencies": {
    "@angular/animations": "^20.1.2",
    "@angular/cdk": "^20.1.2",
    "@angular/common": "^20.1.2",
    "@angular/compiler": "^20.1.2",
    "@angular/core": "^20.1.2",
    "@angular/forms": "^20.1.2",
    "@angular/google-maps": "^19.0.0",
    "@angular/material": "^20.1.2",
    "@angular/platform-browser": "^20.1.2",
    "@angular/platform-browser-dynamic": "^20.1.2",
    "@angular/router": "^20.1.2",
    "@datadog/browser-rum": "^5.29.1",
    "@microsoft/signalr": "^8.0.7",
    "@ngneat/hot-toast": "^5.0.2",
    "@ngneat/overview": "^3.0.0",
    "@types/jszip": "^3.4.0",
    "angular-code-input": "^2.0.0",
    "bootstrap": "^5.3.3",
    "file-saver": "^2.0.5",
    "jszip": "^3.10.1",
    "jwt-decode": "^4.0.0",
    "lottie-web": "^5.12.2",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.45",
    "ng-multiselect-dropdown": "^0.3.9",
    "ng-otp-input": "^1.9.3",
    "ngx-cookie-service": "^20.0.1",
    "ngx-lottie": "^20.0.0",
    "ngx-permissions": "^15.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.1.1",
    "@angular/cli": "~20.1.1",
    "@angular/compiler-cli": "^20.1.2",
    "@types/file-saver": "^2.0.7",
    "@types/google.maps": "^3.53.0",
    "@types/googlemaps": "^3.43.3",
    "@types/jasmine": "~4.3.0",
    "@types/node": "^18.19.58",
    "jasmine-core": "~4.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "prettier": "^3.6.2",
    "prettier-plugin-organize-imports": "^4.1.0",
    "prettier-plugin-packagejson": "^2.5.19",
    "typescript": "~5.8.3"
  },
  "buildDate": 1784289097336
}